import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';

const CustomEventLeaderboardHeader = ({ logo, patronLogo }) => {
    return (
        <div className="custom-event-leaderboard__control-panel">
            <div className="custom-event-leaderboard__logo">
                <SitecoreImageField img={logo} />
            </div>
            <div className="custom-event-leaderboard__patron">
                <SitecoreImageField img={patronLogo} />
            </div>
        </div>
    );
};

export default CustomEventLeaderboardHeader;
